module.exports = __webpack_public_path__ + "img/Home_Header-01.9a6b4eb1.jpg";